module.exports = __webpack_public_path__ + "img/Helfer_psFK.a018f9ed.svg";